import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RefineChecklist from './RefineChecklist/RefineChecklist';
import { Hidden } from 'seek-style-guide/react';

export default class ClassificationList extends Component {
  static propTypes = {
    classifications: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        displayCount: PropTypes.string,
        isActive: PropTypes.bool.isRequired,
        refineParams: PropTypes.object.isRequired
      })
    ).isRequired,
    path: PropTypes.string.isRequired,
    handleSelection: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
  };

  shouldComponentUpdate({ open }) {
    return open;
  }

  render() {
    const { classifications, path, handleSelection, ...props } = this.props;

    return (
      <nav {...props} role="navigation" data-automation="searchClassification">
        <Hidden mobile desktop component="h1">
          Classifications
        </Hidden>
        <RefineChecklist
          handleSelection={handleSelection}
          options={classifications}
          childrenKey="children"
          path={path}
        />
      </nav>
    );
  }
}
